import { Field } from 'react-final-form'
import React from 'react'
import ImageDropZone from 'components/ImageDropZone'

const ImageField = ({
  id,
  type,
  name,
  label,
  helperText,
  variant,
  validate,
  InputProps,
  children,
  ...props
}) => {
  return (
    <Field
      name={name}
      type={type}
      validate={validate}
    >
      {({ input, meta }) => {
        const {
          onChange,
          value
        } = input

        return (
          <ImageDropZone
            onChange={onChange}
            value={value}
            error={meta.error}
          >
            {children}
          </ImageDropZone>
        )
      }}
    </Field>
  )
}

export default ImageField
